import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { HttpClient } from '@angular/common/http';
import { FormFieldConfig } from '../dropdown/form_field_config';
import { SelectionModel } from '@angular/cdk/collections';
import { debounceTime, tap, switchMap, distinctUntilChanged, filter } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { HttpclientService } from 'src/app/admin/core/services/httpclientService';
import { Parametre } from 'src/app/shared/entities/parametre';
import { Tables } from 'src/app/shared/entities/tables';
import { MatDialog } from '@angular/material/dialog';
import { DashboardComponent } from 'src/app/admin/core/components/dashboard/dashboard.component';
import { UserService } from 'src/app/admin/core/services/user.service';
import { Language } from 'src/app/shared/entities/language';
import { DynamicDocumentManageFieldComponent } from '../dynamic-document-manage-field/dynamic-document-manage-field.component';
import {
    ConditionType,
    DynamicDocumentFieldInfo,
    DynamicDocumentFieldInfoType,
    DynamicDocumentRequest,
    Filter,
} from 'src/app/shared/entities/dynamic-document';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-data-table',
    templateUrl: './data-table.component.html',
    styleUrls: ['./data-table.component.css'],
})
export class DataTableComponent implements OnInit {
    datasource: MatTableDataSource<any> = new MatTableDataSource<any>();
    autocomplete: any;
    displayedColumns: string[] = ['delete'];
    pageIndex: number = 1;
    pageSize: number = 10;
    filters: any = {};
    entite: any;
    tab: Tables = new Tables();
    parameters: Parametre[];
    entiteRelationProperte: any;
    @Input() config: FormFieldConfig;
    selection = new SelectionModel<any>(true, []);
    clickSelection = new Set<any>();
    recherche: any;
    minLengthTerm = 3;
    searchArticlesCtrl = new FormControl();
    filteredArticles: any;
    selectedArticle: any;
    isWholeEntite = false;
    visible = true;
    languges: Language[] = [];
    nom: any;
    @Input()
    locales: string[] = environment.languages.map((lang) => lang.locale);

    typeName: any = '';

    isDynamicDocumentInfo = false;
    isDynamicDocument = false;
    dispatchSearchEvent = new BehaviorSubject<string>('');

    @Output()
    addField: EventEmitter<DynamicDocumentFieldInfo> = new EventEmitter();
    @Output()
    updateField: EventEmitter<DynamicDocumentFieldInfo> = new EventEmitter();
    get onlyOneValue(): boolean {
        return (
            (this.entite == 'user' || this.entite == 'personnemorale') &&
            this.datasource.data.length == 1
        );
    }

    get hideAutocomplete(): boolean {
        return this.entite == 'personnephysique';
    }

    constructor(
        private httpClient: HttpClient,
        private httpClientService: HttpclientService,
        private dialog: MatDialog,
        private dash: DashboardComponent,
        private dynamicDocumentService: DynamicDocumentService,
        public userService: UserService,
        private datePipe: DatePipe
    ) {}

    ngOnInit(): void {
        if (this.config.entity == 'dynamic_document_info') {
            this.setTable();
            this.isDynamicDocumentInfo = true;
        } else {
            this.isDynamicDocument = this.config.isDynamic;
            this.populateTable();
        }

        this.dispatchSearchEvent
            .pipe(
                distinctUntilChanged(),
                debounceTime(300),
                tap(() => {
                    this.filteredArticles = [];
                })
            )
            .subscribe((searhValue) => {
                if (searhValue) {
                    let filter: Filter = {
                        conditions: [{ type: ConditionType.CONTAINS, value: searhValue }],
                        fieldName: this.config.referenceField,
                    };
                    let dynamicDocumentRequest: DynamicDocumentRequest = {
                        collectionName: this.config.documentLinkName,
                        filters: [filter],
                        locales: this.locales,
                        page: 1,
                        sorts: new Map(),
                        pageSize: 10,
                    };
                    if (searhValue.length) {
                        this.dynamicDocumentService
                            .find(dynamicDocumentRequest, true)
                            .subscribe((res: any) => {
                                this.filteredArticles = res.content;
                            });
                    }
                }
            });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['config']) {
            this.config.id = '4';
            this.config = changes['config']?.currentValue;

            this.displayedColumns = this.config.displayedColumns;

            if (this.config.displayedColumns.indexOf('delete') === -1) {
                this.displayedColumns.push('delete');
            }
            this.entiteRelationProperte = this.config.entiteRelationProperte;
            if (
                this.config?.entiteRelationProperte?.toLocaleLowerCase() ===
                this.config?.linkedEntite?.toLocaleLowerCase()
            ) {
                this.isWholeEntite = true; // on a toute l'entite dans la
            }
            this.entite = this.config.linkedEntite;

            //console.log(this.config.typeName+ " "+this.config.name);
            // if (this.config.visibilityCheckProperte) {
            //   this.typeName = this.config['visibilityCheckProperte'];
            //   this.visible =
            //     this.config.typeName === this.config['visibilityCheckValue'];
            // }
        }
    }
    suprimme(row: any) {
        this.config.idList = this.config?.idList.filter((item) => {
            if (item?.documentId) {
                return row?.id !== null && item.documentId !== row?.id;
            } else {
                return row?.id !== null && item !== row?.id;
            }
        });
        this.config.entiteList = this.config?.entiteList.filter((item) => {
            if (item?.documentId) {
                return row?.id !== null && item.documentId !== row?.id;
            } else {
                return row?.id !== null && item !== row?.id;
            }
        });

        this.datasource.data = this.datasource.data.filter((item) => item !== row);
    }

    filtreMotCles(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.datasource.filter = filterValue.trim().toLowerCase();
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.datasource.data.length;
        return numSelected === numRows;
    }

    masterToggle() {
        if (this.isAllSelected()) {
            this.selection.clear();
            return;
        }
        this.selection.select(...this.datasource.data);
    }

    checkboxLabel(element?: any): string {
        if (!element) {
            return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
        }
        return `${this.selection.isSelected(element) ? 'deselect' : 'select'} row ${
            element.id + 1
        }`;
    }

    setTable() {
        this.datasource.data = this.config.entiteList;
        this.datasource.filteredData = this.datasource.data;
    }

    populateTable() {
        if (this.filters === undefined || this.filters === null) {
            this.filters = [];
        } else if (Array.isArray(this.filters)) {
            for (let filter of this.filters) {
                this.filters[filter.champ] = filter;
            }
        }

        if (!this.isWholeEntite && this.config.idList && this.config.idList.length > 0) {
            // si on a des id
            this.getData();
        } else if (
            this.isWholeEntite &&
            this.config.entiteList &&
            this.config.entiteList.length > 0
        ) {
            // si on a des id
            this.datasource.data.push(...this.config.entiteList);
        }
    }

    getData() {
        let ids = this.config.idList.map((el) => (el.documentId ? el.documentId : el));
        if (ids) {
            ids = ids.filter((x) => x !== null);
            // if (typeof this.config.idList[0] !== 'string') {
            //   this.config.idList = this.config.idList.map((item) => item.id);
            // }
            let entite = this.config.isDynamic ? this.config.documentLinkName : this.entite;
            this.httpClient
                .post<any[]>(`/view/filtrerById/${entite.trim().toLowerCase()}`, ids)
                .subscribe((data: any) => {
                    this.datasource.data = data.response;
                });
        }
    }

    getValueOld(val: any) {
        return val?.titre
            ? val?.titre
            : val?.email
            ? val?.email
            : val?.nom
            ? val?.nom
            : val?.name
            ? val?.name
            : val?.code
            ? val?.code
            : val?.famille
            ? val?.famille
            : val?.label
            ? val?.label[this.locales[0]]
            : val?.[this.config.referenceField]
            ? val?.[this.config.referenceField]
            : val?.fr_FR
            ? val.fr_FR
            : val?.value
            ? val.value
            : Array.isArray(val)
            ? val.map((item) => item.value).join(' ')
            : val;
    }

    getValue(val: any, columnName?: string) {
        // First, your existing checks
        const fallbackValue = val?.titre
            ? val?.titre
            : val?.email
            ? val?.email
            : val?.nom
            ? val?.nom
            : val?.name
            ? val?.name
            : val?.code
            ? val?.code
            : val?.famille
            ? val?.famille
            : val?.label
            ? val?.label[this.locales[0]]
            : val?.[this.config.referenceField]
            ? val?.[this.config.referenceField]
            : val?.fr_FR
            ? val.fr_FR
            : val?.value
            ? val.value
            : Array.isArray(val)
            ? val.map((item) => item.value).join(' ')
            : val;

        // Check if the final fallback is a date (timestamp, ISO string, or column name suggests date)
        const isDateColumn = columnName?.toLowerCase().includes('date');

        // Check if it's a timestamp (milliseconds)
        if (
            typeof fallbackValue === 'number' &&
            fallbackValue.toString().length >= 12 &&
            isDateColumn
        ) {
            const date = new Date(fallbackValue);
            if (!isNaN(date.getTime())) {
                // Format as DD/MM/YYYY
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            }
        }

        // Check if it's an ISO date string (YYYY-MM-DD or YYYY-MM-DDTHH:mm:ss)
        if (typeof fallbackValue === 'string' && isDateColumn) {
            // Match ISO date patterns: YYYY-MM-DD or YYYY-MM-DDTHH:mm:ss
            const isoDatePattern = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2})?/;
            if (isoDatePattern.test(fallbackValue)) {
                const date = new Date(fallbackValue);
                if (!isNaN(date.getTime())) {
                    // Format as DD/MM/YYYY
                    const day = String(date.getDate()).padStart(2, '0');
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const year = date.getFullYear();
                    return `${day}/${month}/${year}`;
                }
            }
        }

        // Check if it's a Date object
        if (fallbackValue instanceof Date && isDateColumn) {
            if (!isNaN(fallbackValue.getTime())) {
                // Format as DD/MM/YYYY
                const day = String(fallbackValue.getDate()).padStart(2, '0');
                const month = String(fallbackValue.getMonth() + 1).padStart(2, '0');
                const year = fallbackValue.getFullYear();
                return `${day}/${month}/${year}`;
            }
        }

        return fallbackValue;
    }

    isDeleteDisabled(element: any): any {
        return ['id', 'lastModifiedUser', 'creationDate', 'updatingDate'].includes(element?.name);
    }

    autocompleteSearch(event: any) {
        if (this.config.isDynamic) {
            this.dispatchSearchEvent.next(this.searchArticlesCtrl?.value);
        } else {
            this.searchArticlesCtrl.valueChanges
                .pipe(
                    filter((res) => {
                        return (
                            res !== null && res !== undefined && res.length >= this.minLengthTerm
                        );
                    }),
                    distinctUntilChanged(),
                    debounceTime(300),
                    tap(() => {
                        this.filteredArticles = [];
                    }),
                    switchMap((value) => {
                        return this.httpClientService.post(
                            {
                                entite: this.entite,
                                query: value,
                                filter: this.config.filter,
                                page: this.pageIndex,
                                size: this.pageSize,
                            },
                            'view/autocompletepost'
                        );
                    })
                )
                .subscribe((res: any) => {
                    this.filteredArticles = res.content;
                });
        }
    }

    // autocompleteSearch(event: any) {
    //   this.searchArticlesCtrl.valueChanges
    //     .pipe(
    //       filter((res) => {
    //         return (
    //           res !== null &&
    //           res !== undefined &&
    //           res.length >= this.minLengthTerm
    //         );
    //       }),
    //       distinctUntilChanged(),
    //       debounceTime(100),
    //       tap(() => {
    //         this.filteredArticles = [];
    //       }),
    //       switchMap((value) => {
    //         return this.httpClientService.get(
    //           `view/autocomplete?entite=${this.entite}&q=${value}&f=${this.estArticle}&page=${this.pageIndex}&size=${this.pageSize}&l=${this.locals}`
    //         );
    //       })
    //     )
    //     .subscribe((res: any) => {
    //       this.filteredArticles = res.content;
    //     });
    // }
    // addItem(data: any) {
    //   if (this.config.idList === undefined || this.config.idList === null) {
    //     this.config.idList = [];
    //   }
    //   if (
    //     this.config.entiteList === undefined ||
    //     this.config.entiteList === null
    //   ) {
    //     this.config.entiteList = [];
    //   }

    //   if (
    //     this.isWholeEntite &&
    //     this.config.entiteList.filter((item) => item.id === data.id).length <= 0
    //   ) {
    //     this.config.entiteList.push(data);
    //     this.datasource.data = [...this.datasource.data, data];
    //   }
    //   if (!this.isWholeEntite && this.config.idList.indexOf(data.id) === -1) {
    //     this.config.idList.push(data.id);
    //     //this.config.entiteList.push(data.id);
    //     this.datasource.data = [...this.datasource.data, data];
    //   }
    // }
    addItem(data: any) {
        if (this.config.idList === undefined || this.config.idList === null) {
            this.config.idList = [];
        }
        if (this.config.entiteList === undefined || this.config.entiteList === null) {
            this.config.entiteList = [];
        }

        if (this.config.type == DynamicDocumentFieldInfoType.DOCUMENT_LINK) {
            this.datasource.data = [data];
            this.config.idList = [data.id];
        }

        if (
            this.isWholeEntite &&
            this.config.entiteList.filter((item) => item.id === data.id).length <= 0
        ) {
            this.config.entiteList.push(data);

            if (!this.datasource.data.some((item) => item.id === data.id)) {
                this.datasource.data = [...this.datasource.data, data];
            }
        }

        if (!this.isWholeEntite && this.config.idList.indexOf(data.id) === -1) {
            this.config.idList.push(data.id);

            //this.config.entiteList.push(data.id);
            if (!this.datasource.data.some((item) => item.id === data.id)) {
                this.datasource.data = [...this.datasource.data, data];
            }
        }

        if (data?.mapDescriptionVl) {
            this.searchArticlesCtrl.setValue(data?.mapDescriptionVl?.fr_FR); // set the initial value of the control
        }
    }

    convertDate(data: any): any {
        let fieldConfig: any = {};
        try {
            fieldConfig.value = this.datePipe.transform(data, 'dd/MM/yyyy');
        } catch (error) {
            const monthMap: any = {
                jan: '01',
                fev: '02',
                mars: '03',
                avr: '04',
                mai: '05',
                juin: '06',
                juil: '07',
                aout: '08',
                sept: '09',
                oct: '10',
                nov: '11',
                dec: '12',
                déc: '12',
            };

            // For example : convert 25-oct.-1995 to 25/10/1995
            let date = data?.split('-');
            if (date.length === 3) {
                date[1] = date[1].replace('.', '');
                if (date[1] in monthMap) {
                    date[1] = monthMap[date[1]];
                }
                data = date.join('-');

                // Reformatage de la date en 'yyyy-MM-dd' pour utilisation avec Date object
                let formattedDate = `${date[2]}-${date[1]}-${date[0]}`;
                let dateObject = new Date(formattedDate);

                if (!isNaN(dateObject.getTime())) {
                    // Transformer la date en format 'dd/MM/yyyy'
                    fieldConfig.value = this.datePipe.transform(dateObject, 'dd/MM/yyyy');
                } else {
                    console.error('La date transformée est invalide');
                }
            } else {
                // For example : convert Fri Feb 16 07:00:00 CET 2024 to 16/02/2024
                let date: any = new Date(data);
                if (isNaN(date)) {
                    const parts = data.match(/\w+ (\w+) (\d+) (\d+:\d+:\d+) CET (\d+)/);
                    if (parts) {
                        date = new Date(`${parts[2]} ${parts[1]} ${parts[4]} ${parts[3]}`);
                    }
                }
                fieldConfig.value = this.datePipe.transform(date, 'dd/MM/yyyy');
            }
        }
        return fieldConfig.value;
    }

    ouvrirOnglet(data: any) {
        if (this.isDynamicDocumentInfo) {
            this.dialog
                .open(DynamicDocumentManageFieldComponent, {
                    data: { field: data == 'add' ? null : data, editMode: this.config.editMode },
                })
                .afterClosed()
                .subscribe((field) => {
                    if (field) {
                        data == 'add' ? this.addField.emit(field) : this.updateField.emit(field);
                        setTimeout(() => {
                            this.setTable();
                        }, 50);
                    }
                });
        } else if (!this.config.editMode) {
            this.nom = data[this.displayedColumns[1]];

            if (this.entite === 'Picto') {
                this.nom = data['label'];
                this.nom = this.nom?.fr_FR;
                // on prend la valeur en francais par defaut we need to change this
            } else if (data?.mapDescriptionVl && data?.mapDescriptionVl?.fr_FR) {
                this.nom = data?.mapDescriptionVl?.fr_FR;
            }

            if (this.isDynamicDocument) {
                this.entite = this.config.documentLinkName;
                this.nom = data[this.config.referenceField];
            }

            this.dash.visualisation(
                this.nom,
                this.entite,
                `${data.id}`,
                '',
                this.config.idList?.length,
                ''
            );
        }
    }
}
